module.exports = __webpack_public_path__ + "static/media/bed-moving-Icon-1.074675c1.svg";